<template>
  <div v-if="fetchingProfile">
    <v-skeleton-loader type="text" width="100" class="mb-4" />
    <div class="d-flex">
      <v-skeleton-loader type="chip" class="me-2" />
      <v-skeleton-loader type="chip" class="me-2" />
      <v-skeleton-loader type="chip" class="me-2" />
    </div>
  </div>
  <div v-else>
    <p class="subtitle-2 ma-0 pa-0 px-2 mb-4" style="font-weight: 700">
      {{ $t('profile_settings.skill_other') }}
    </p>
    <div v-if="showSkills" class="d-flex flex-wrap">
      <v-chip outlined v-for="skill in skills" class="me-2 mb-2" :key="skill">{{
        skill
      }}</v-chip>
    </div>
    <v-sheet
      v-else
      outlined
      rounded
      class="pa-4 mx-2 d-flex align-center justify-space-between"
    >
      <div class="d-flex">
        <v-icon size="24" color="blue-grey lighten-1" class="me-3"
          >mdi-ghost-outline</v-icon
        >
        <p class="body-2 ma-0 pa-0  blue-grey--text text--darken-1">
          {{ $t('profile.skills_empty_state') }}
        </p>
      </div>
      <Button
        v-if="isSelfProfile"
        plain
        size="small"
        color="primary"
        icon="mdi-plus"
        iconPosition="right"
        @click="goToProfileSettings"
      />
    </v-sheet>
  </div>
</template>

<script>
import Button from '@/components/UI/Button'
import trackerMixin from '@/mixins/tracking/trackerMixin.vue'
import mixin from '@/mixins/mixin.vue'

export default {
  name: 'Skills',

  mixins: [trackerMixin, mixin],

  components: {
    Button,
  },

  props: {
    skills: {
      type: Array,
      required: true,
    },
    isSelfProfile: {
      type: Boolean,
      required: true,
    },
    fetchingProfile: {
      type: Boolean,
      required: true,
    },
  },

  computed: {
    showSkills() {
      return Boolean(this.skills?.length)
    },
  },

  methods: {
    goToProfileSettings() {
      this.trackProfileNavigate({
        element: 'addSkillsButton',
        section: 'summary',
      })
      this.navigateTo({
        name: 'profileSettings',
        query: { option: 'SKILLS' },
      })
    },
  },
}
</script>
<style lang="scss">
.skill {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
</style>
